import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { postAsync } from '@/helpers/http-request'

export const useConfirmEmail = (token: string | null) => {
  const { t } = useTranslation();

  const { isLoading, isSuccess, isError, error } = useQuery({
    queryKey: ['confirmEmail', token],
    queryFn: async (): Promise<boolean> => {
      const response = await postAsync('/web/v1/user/confirmEmail', { token })
      if (!response.ok) {
        throw new Error(response.status === 500 ? 'serverError' : 'linkExpired');
      }
      return true;
    },
    enabled: !!token,
    retry: false,
  });

  const errorMessage = !token ?
      t('errors.incompleteUrl') : error ?
      t((error as Error).message === 'serverError' ?
      'errors.unknownServerError' : 'errors.linkExpiredEmail') : null;

  return {
    isLoading,
    isSuccess,
    isError: isError || !token,
    error: errorMessage,
  };
}

export default useConfirmEmail;
